import { render } from "./VueReactionButton.vue?vue&type=template&id=dae55f6c&ts=true&lang=pug"
import script from "./VueReactionButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VueReactionButton.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/components/VueReactionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dae55f6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dae55f6c', __exports__)) {
    api.reload('dae55f6c', __exports__)
  }
  
  module.hot.accept("./VueReactionButton.vue?vue&type=template&id=dae55f6c&ts=true&lang=pug", () => {
    api.rerender('dae55f6c', render)
  })

}


export default __exports__